import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../core/store';
import { EProductReservationTabs } from '../../types';

export interface SettingsState {
    currentTab: EProductReservationTabs;
    redirectLink: string;
    appLink: string;
}

const initialState: SettingsState = {
    currentTab: EProductReservationTabs.configurationDocumentLink,
    redirectLink: '/access-denied',
    appLink: '',
};

const settingsSlice = createSlice({
    name: 'productReservation/settings',
    initialState,
    reducers: {
        setCurrentTab(state, action: PayloadAction<EProductReservationTabs>) {
            state.currentTab = action.payload;
        },
        setRedirectLink(state, action: PayloadAction<string>) {
            state.redirectLink = action.payload;
        },
        setAppLink(state, action: PayloadAction<string>) {
            state.appLink = action.payload;
        },

    },
});

// Selectors
const getSettings = (state: RootState) => state.productReservation.settings;

const getCurrentTab = createSelector(getSettings, (settings) => settings.currentTab);
const getRedirectLink = createSelector(getSettings, (settings) => settings.redirectLink);
const getAppLink = createSelector(getSettings, (settings) => settings.appLink);

// Export
export const settingsReducer = settingsSlice.reducer;
export const actions = { ...settingsSlice.actions };
export const selectors = {
    getSettings,
    getCurrentTab,
    getRedirectLink,
    getAppLink,
};
